parseTokensYYYYY